<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="36" />
        </span>
        <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
      </a>
    </li>
    <li>
      <navbar-tenant class="d-lg-none"></navbar-tenant>
    </li>
  </ul>
</div>

<div class="navbar-container d-flex content">
  <div class="bookmark-wrapper d-flex align-items-center">
    <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>

    <navbar-tenant class="d-none d-lg-block"></navbar-tenant>
  </div>
  <ul class="nav navbar-nav align-items-center ml-auto">
    <li class="nav-item d-none d-lg-block">
      <a class="nav-link nav-link-style btn" (click)="toggleDarkSkin()">
        <span
          [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'"
          class="ficon font-medium-5 feather"
        ></span>
      </a>
    </li>
    <app-navbar-search></app-navbar-search>
    <!-- <li
      class="nav-item d-none d-lg-block"
      *ngIf="currentUser?.role === 1 || currentUser?.role === 2"
    >
      <a
        class="nav-link nav-link-style btn"
        routerLink="utrav/push/dashboard"
        title="Dashboard Notifications Push"
      >
        <i data-feather="bell" class="ficon font-medium-5"></i>
        <span *ngIf="failedPushNotifications > 0" class="badge badge-pill badge-danger badge-up">
          {{ failedPushNotifications }}
        </span>
      </a>
    </li> -->
    <app-navbar-notification></app-navbar-notification>
    <li ngbDropdown class="nav-item dropdown-user">
      <a
        class="nav-link dropdown-toggle dropdown-user-link"
        id="dropdown-user"
        ngbDropdownToggle
        id="navbarUserDropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <ng-container *ngIf="currentUser">
          <div class="user-nav d-sm-flex d-none">
            <span class="user-name font-weight-bolder">{{ currentUser.fullName }}</span>
            <!-- Affichage du rôle dynamique depuis currentRole -->
            <span
              *ngIf="currentRole"
              class="mt-25 badge badge-pill"
              [ngStyle]="{
                'background-color': currentRole.color ? currentRole.color + '20' : '#7367f020',
                color: currentRole.color || '#7367f0'
              }"
            >
              <span
                *ngIf="currentRole.icon"
                [innerHTML]="currentRole.icon | featherIcon : 12"
                class="mr-25"
              ></span>
              {{ currentRole.name }}
            </span>
            <!-- Fallback: affichage du roleName sans style si pas de currentRole -->
            <span
              *ngIf="!currentRole && currentPermissions?.roleName"
              class="mt-25 badge badge-pill badge-light-primary"
            >
              {{ currentPermissions.roleName }}
            </span>
            <span
              *ngIf="!currentRole && !currentPermissions?.roleName && currentUser.isGlobalAdmin"
              class="mt-25 badge badge-pill badge-light-{{ roles[5]?.color }}"
            >
              <fa-icon *ngIf="roles[5].icon" [icon]="roles[5].icon" class="mr-25"></fa-icon>
              {{ roles[5]?.label }}
            </span>
            <span
              *ngIf="
                !currentRole &&
                !currentPermissions?.roleName &&
                !currentUser.isGlobalAdmin &&
                currentUser.role
              "
              class="mt-25 badge badge-pill badge-light-{{ roles[currentUser.role - 1]?.color }}"
            >
              <fa-icon
                *ngIf="roles[currentUser.role - 1]?.icon"
                [icon]="roles[currentUser.role - 1].icon"
                class="mr-25"
              ></fa-icon>
              {{ roles[currentUser.role - 1]?.label }}
            </span>
          </div>
          <avatar
            [fullName]="currentUser?.fullName"
            [avatar]="currentUser?.profilePictureUrl"
            [size]="40"
            [isStatic]="true"
          ></avatar>
        </ng-container>
      </a>
      <div
        ngbDropdownMenu
        aria-labelledby="navbarUserDropdown"
        class="dropdown-menu dropdown-menu-right"
      >
        <a ngbDropdownItem [routerLink]="['/utrav/settings']">
          <span [data-feather]="'settings'" [class]="'mr-50'"></span>
          Paramètres
        </a>
        <a ngbDropdownItem [routerLink]="['/utrav/tutorial']">
          <span [data-feather]="'book-open'" [class]="'mr-50'"></span>
          Guide
        </a>
        <div class="dropdown-divider"></div>
        <a ngbDropdownItem (click)="logout()">
          <span [data-feather]="'power'" [class]="'mr-50'"></span> Déconnexion
        </a>
      </div>
    </li>
  </ul>
</div>
